/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Endpoint } from '../index';
import { z, ZodTypes } from '../zod';

const Params = z.strictObject({ requestTypeId: ZodTypes.Id });

export const JiraTypesFieldsGet = {
  id: 'jira-types-fields.get',
  tag: 'Support',
  summary: 'Jira type fields',
  description: 'Get fields by request type',
  method: 'get',
  flags: { isAuthorized: true },
  route: (params: z.infer<typeof Params>) => `/jira/types/${params.requestTypeId}/fields`,
  request: { params: Params },
  response: {
    200: {
      description: 'successful',
      content: {
        'application/json': {
          schema: z.array(
            z.strictObject({
              fieldId: z.string(),
              name: z.string(),
              description: z.string(),
              required: z.boolean(),
              defaultValues: z.array(z.any()),
              validValues: z.array(z.any()),
              schema: z.any(),
            }),
          ),
        },
      },
    },
  },
} as const satisfies Endpoint;
